import React from "react";
import "./buttonAddHL.css";

/**
 * @typedef {object} PropsCustom
 * @property {string} nameBtn - Text in button
 * @property {function} onClickBtn - Function to call on button click
 * @property {boolean} iconAdd - True to use plus icon and false to custom icon
 * @property {string} customIcon - Choose a icon
 * @property {boolean} disabled - True to disabled button, false not disabled
 */

/** @typedef {Omit<import('react').ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & PropsCustom} Props */

/**
* @param {Props} props
*/
const ButtonAddHLPure = ({ nameBtn, onClickBtn, iconAdd, customIcon, disabled, ...props }) => {

  return (
    <button
      disabled={disabled}
      className="buttonAddHLPure-add"
      {...props}
      onClick={(e) => onClickBtn(e)}
    >
      {iconAdd ? (
        <i className={"k-icon k-i-plus buttonAddHLPure-iconPlus-Style"}></i>
      ) : customIcon && (
        <img src={customIcon} className="buttonAddHLPure-customIcon" />
      )}

      {nameBtn}
    </button>
  );
};

export { ButtonAddHLPure as default };
